import React from "react";
import Button from "../../components/buttons/Button";
import Input from "../../components/inputs/Input";
import Text from "../../components/typography/Text";

export default ({ data, setData, next, btnLabel, saved }) => {
  return (
    <div className="oUserForm">
      <h3>Website and social</h3>
      <h4>Website</h4>
      <Input
        label="URL"
        value={data["website"]}
        setValue={value => setData({ field: "website", value })}
      />
      <div className="oUserForm_socials">
        <h4>Social profiles</h4>
        <Text>Copy/paste URL of your social networks.</Text>
        <div className="oUserForm_inputs">
          <Input
            label="Linkedin"
            icon="linkedin"
            value={data["linkedin"]}
            setValue={value => setData({ field: "linkedin", value })}
          />
          <Input
            label="Twitter"
            icon="twitter"
            value={data["twitter"]}
            setValue={value => setData({ field: "twitter", value })}
          />
        </div>
      </div>
      {saved ? (
        <Button big green full>
          Saved !
        </Button>
      ) : (
        <Button onClick={next} big full>
          {btnLabel || "Continue"}
        </Button>
      )}
    </div>
  );
};
